import { Outlet } from 'react-router-dom';
import { FlashWrapper } from 'components/FlashMessages';
import { AuthedHeader } from 'components/Layout/AuthedLayout/AuthedHeader';
import { SkipLinks } from 'components/SkipLinks';
import { WormholeExit } from 'components/Wormhole';
import { Footer } from 'components/Footer';

export const AuthedLayout: React.FC = () => {
  return (
    <>
      <SkipLinks />
      <AuthedHeader />

      <WormholeExit loc="header" />

      <main id="maincontent" tabIndex={-1} className="bg-cream-50 max-w-[100vw]">
        <FlashWrapper />
        <Outlet />
      </main>
      
      <Footer />
    </>
  );
};
